import ContentLoader from "react-content-loader";
import { merge } from "react-merge";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";

const loaderStyle = {
  mobile : {
    width: "90.34vw",
    backgroundColor: Color.White, 
    padding: "0 2.13vw",
    zIndex: "1",
    height: "99.51vw"      
  },
  desktop: {
    borderRadius: "0.52vw",
    width: "42.29vw",
    height: "20.83vw",
    marginLeft: "-3.00vw",
    marginBottom: "1.00vw"      
  }
};

export const RecruiterProfileLoader : React.FC = () => {
  const isMobile = useMediaQuery ({ query : "(max-width: 786px)"});
  var styles = loaderStyle.mobile;
  if(!isMobile) {
    let extendedStyle = merge(loaderStyle.mobile, loaderStyle.desktop);
    styles = extendedStyle;
  }

  return(        
    <div style={styles}>
      <ContentLoader
        speed={1}
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
        width= "auto"
        height= {styles.height}
      > 
        {isMobile ? <>
          <rect x="4%" y="0" rx="3" ry="3" width="21.92%" height="5.58%" />
          <rect x="0" y="6.79%" rx="3" ry="3" width="100%" height="12.13%" />
          <rect x="4%" y="23.78%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="30.58%" rx="3" ry="3" width="100%" height="12.13%" />
          <rect x="4%" y="57.28%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="64.07%" rx="3" ry="3" width="100%" height="12.13%" />
          <rect x="4%" y="81.06%" rx="3" ry="3" width="22.92%" height="5.58%" />
          <rect x="0" y="87.67%" rx="3" ry="3" width="100%" height="12.13%" />
        </> : 
        <>
          <rect x="1.25%" y="0" rx="3" ry="3" width="11.33%" height="6.25%" />
          <rect x="52.21%" y="0" rx="3" ry="3" width="11.33%" height="6.25%" />
          <rect x="0" y="8.75%" rx="3" ry="3" width="49.01%" height="17.5%" />
          <rect x="50%" y="8.75%" rx="3" ry="3" width="49.01%" height="17.5%" />
          <rect x="1.25%" y="41.25%" rx="3" ry="3" width="6.03%" height="6.25%" />
          <rect x="0" y="50%" rx="3" ry="3" width="100%" height="17.5%" />
          <rect x="1.25%" y="72.5%" rx="3" ry="3" width="12.33%" height="6.25%" />
          <rect x="0" y="81.25%" rx="3" ry="3" width="100%" height="17.5%" />
        </>} 
      </ContentLoader>  
    </div>      
  )
}